import { useEffect } from "react";
import AppLayout from "../layouts/AppLayout.jsx";
import NavEmailMarketing from "../components/NavEmailMarketing.jsx";
import { useNavigate } from "react-router-dom";

export default function Welcome() {

        const navigate = useNavigate();

  useEffect(() => {
    if (!window.bootstrap) return;


    const step1El = document.getElementById("step1Modal");
    const draftPromptEl = document.getElementById("draft-prompt");

    if (draftPromptEl) {
      const draftPromptInstance =
        window.bootstrap.Modal.getOrCreateInstance(draftPromptEl);
      draftPromptInstance.hide();
    }

    if (step1El) {
      const step1Instance = window.bootstrap.Modal.getOrCreateInstance(step1El);
      step1Instance.show();
    }
  }, []);

  const placeholders = Array.from({ length: 6 });

  return (
    <AppLayout currentPage="emails">
      <NavEmailMarketing currentPage="emails" />

      <div className="row g-2" id="caption-list">
        {placeholders.map((_, index) => (
          <div className="col-md-4 placeholder-item" key={index}>
            <div className="card rounded-4 h-100 border caption animate__animated animate__fadeIn animate__slow">
              <div className="card-header bg-white rounded-4 border-0 p-3 pb-0">
                <div className="mb-2 categories">
                  <span className="placeholder col-6"></span>
                </div>
                <h5 className="card-title fs-5 mb-0">
                  <span className="placeholder col-8"></span>
                </h5>
              </div>

              <div className="card-body">
                <p className="card-text caption-content">
                  <span className="placeholder col-7"></span>
                  <br />
                  <span className="placeholder col-4"></span>
                  <br />
                  <span className="placeholder col-6"></span>
                  <br />
                  <span className="placeholder col-8"></span>
                  <br />
                </p>
              </div>

              <div className="card-footer rounded-bottom-4 bg-transparent p-3">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <button
                      type="button"
                      className="btn btn-outline-primary disabled placeholder"
                      disabled
                    >
                      + Use
                    </button>
                  </div>

                  <div className="col text-end action-buttons">
                    <span className="placeholder col-1 me-2"></span>
                    <span className="placeholder col-1 me-2"></span>
                    <span className="placeholder col-1"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div
        className="modal fade"
        id="step1Modal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="step1ModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content rounded-4">
            <div className="modal-body p-4">
              <div className="row">
                <div className="col-md-6">
                  <div className="d-flex flex-column justify-content-between h-100 p-5">
                    <div className="d-flex align-items-center">
                      <span className="bg-secondary rounded-pill text-primary px-2 py-1 small fw-bold">
                        STEP 1
                      </span>
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary ms-3"
                      ></span>
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary ms-3"
                      ></span>
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary ms-3"
                      ></span>
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary ms-3"
                      ></span>
                    </div>

                    <div className="my-4">
                      <h2 className="fw-bold">
                        Welcome aboard — <br />
                        your Al co-pilot is ready.
                      </h2>
                      <p className="fs-5">
                        We&apos;ve already curated your first batch of
                        ready-to-post content
                      </p>
                    </div>

                    <div className="d-flex justify-content-start">
                      <a href="home" className="btn btn-secondary me-3">
                        Skip For Now
                      </a>
                      <button
                        type="button"
                        className="btn btn-primary"
                        data-bs-target="#step2Modal"
                        data-bs-dismiss="modal"
                        data-bs-toggle="modal"
                        onClick={() => {
                          if (typeof window.onboarding_save === "function") {
                            window.onboarding_save();
                          }
                        }}
                      >
                        Next <i className="fi fi-rr-arrow-small-right"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <img
                    src="assets/img/travelagentcollective/Step1.gif"
                    className="img-fluid rounded-5"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="step2Modal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="step2ModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content rounded-4">
            <div className="modal-body p-5">
              <div className="row">
                <div className="col-md-6">
                  <div className="d-flex flex-column justify-content-between h-100 p-5">
                    <div className="d-flex align-items-center">
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary me-3"
                      ></span>
                      <span className="bg-secondary rounded-pill text-primary px-2 py-1 small fw-bold">
                        STEP 2
                      </span>
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary ms-3"
                      ></span>
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary ms-3"
                      ></span>
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary ms-3"
                      ></span>
                    </div>

                    <div className="my-4">
                      <h2 className="fw-bold">One-Click Scheduling</h2>
                      <p className="fs-5">
                        Inside your For You feed, you&apos;ll see posts created
                        by Estelle Al — click ✔ to schedule instantly.
                      </p>
                    </div>

                    <div className="d-flex justify-content-start">
                      <button
                        type="button"
                        className="btn btn-primary me-3"
                        data-bs-target="#step1Modal"
                        data-bs-dismiss="modal"
                        data-bs-toggle="modal"
                      >
                        <i className="fi fi-rr-arrow-small-left"></i> Back
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        data-bs-target="#step3Modal"
                        data-bs-dismiss="modal"
                        data-bs-toggle="modal"
                      >
                        Next <i className="fi fi-rr-arrow-small-right"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <img
                    src="assets/img/travelagentcollective/Step2.gif"
                    className="img-fluid rounded-5"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="step3Modal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="step3ModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content rounded-4">
            <div className="modal-body p-5">
              <div className="row">
                <div className="col-md-6">
                  <div className="d-flex flex-column justify-content-between h-100 p-5">
                    <div className="d-flex align-items-center">
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary me-3"
                      ></span>
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary me-3"
                      ></span>
                      <span className="bg-secondary rounded-pill text-primary px-2 py-1 small fw-bold">
                        STEP 3
                      </span>
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary ms-3"
                      ></span>
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary ms-3"
                      ></span>
                    </div>

                    <div className="my-4">
                      <h2 className="fw-bold">Manage scheduled posts</h2>
                      <p className="fs-5">
                        Under “My Calendar&quot; is where you&apos;ll find your
                        scheduled posts. You can edit scheduled posts, change
                        scheduling times, etc.
                      </p>
                    </div>

                    <div className="d-flex justify-content-start">
                      <button
                        type="button"
                        className="btn btn-primary me-3"
                        data-bs-target="#step2Modal"
                        data-bs-dismiss="modal"
                        data-bs-toggle="modal"
                      >
                        <i className="fi fi-rr-arrow-small-left"></i> Back
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        data-bs-target="#step4Modal"
                        data-bs-dismiss="modal"
                        data-bs-toggle="modal"
                      >
                        Next <i className="fi fi-rr-arrow-small-right"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <img
                    src="assets/img/travelagentcollective/Step3.gif"
                    className="img-fluid rounded-5"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="step4Modal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="step4ModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content rounded-4">
            <div className="modal-body p-5">
              <div className="row">
                <div className="col-md-6">
                  <div className="d-flex flex-column justify-content-between h-100 p-5">
                    <div className="d-flex align-items-center">
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary me-3"
                      ></span>
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary me-3"
                      ></span>
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary me-3"
                      ></span>
                      <span className="bg-secondary rounded-pill text-primary px-2 py-1 small fw-bold">
                        STEP 4
                      </span>
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary ms-3"
                      ></span>
                    </div>

                    <div className="my-4">
                      <h2 className="fw-bold">Marketing Tab</h2>
                      <p className="fs-5">
                        Your Marketing Hub is where you&apos;ll find email
                        templates, post resources, and Business Class trainings.
                      </p>
                    </div>

                    <div className="d-flex justify-content-start">
                      <button
                        type="button"
                        className="btn btn-primary me-3"
                        data-bs-target="#step3Modal"
                        data-bs-dismiss="modal"
                        data-bs-toggle="modal"
                      >
                        <i className="fi fi-rr-arrow-small-left"></i> Back
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        data-bs-target="#step5Modal"
                        data-bs-dismiss="modal"
                        data-bs-toggle="modal"
                      >
                        Next <i className="fi fi-rr-arrow-small-right"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <img
                    src="assets/img/travelagentcollective/Step4.gif"
                    className="img-fluid rounded-5"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="step5Modal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="step5ModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content rounded-4">
            <div className="modal-body p-5">
              <div className="row">
                <div className="col-md-6">
                  <div className="d-flex flex-column justify-content-between h-100 p-5">
                    <div className="d-flex align-items-center">
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary me-3"
                      ></span>
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary me-3"
                      ></span>
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary me-3"
                      ></span>
                      <span
                        style={{ height: "8px", width: "8px" }}
                        className="rounded-circle bg-secondary me-3"
                      ></span>
                      <span className="bg-secondary rounded-pill text-primary px-2 py-1 small fw-bold">
                        STEP 5
                      </span>
                    </div>

                    <div className="my-4">
                      <h2 className="fw-bold">
                        Automate your processes with Estelle Al
                      </h2>
                      <p className="fs-5">
                        Estelle helps you edit captions, build new posts, and
                        personalize your marketing calendar.
                      </p>
                    </div>

                    <div className="d-flex justify-content-between">
                      <button
                        type="button"
                        className="btn btn-primary me-3"
                        data-bs-target="#step4Modal"
                        data-bs-dismiss="modal"
                        data-bs-toggle="modal"
                      >
                        <i className="fi fi-rr-arrow-small-left"></i> Back
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                          const modal = window.bootstrap.Modal.getInstance(
                            document.getElementById("step5Modal"),
                          );
                          modal?.hide();

                          navigate("/for-you");
                        }}
                      >
                        Get Started
                      </button>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <img
                    src="assets/img/travelagentcollective/Step5.gif"
                    className="img-fluid rounded-5"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
